import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import SEO from './components/SEO';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import useScrollToTop from './hooks/useScrollToTop';
import './App.css';

// Component to handle scroll to top functionality
const ScrollToTopHandler: React.FC = () => {
  useScrollToTop();
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <ScrollToTopHandler />
          <SEO />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
